var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorNotify(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "#F7613B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4697 6.46964C6.76261 6.17676 7.23748 6.17679 7.53036 6.4697L10 8.9396L12.4696 6.4697C12.7625 6.17679 13.2374 6.17676 13.5303 6.46964C13.8232 6.76252 13.8232 7.23739 13.5304 7.5303L11.0606 10.0003L13.5297 12.4697C13.8226 12.7626 13.8226 13.2375 13.5297 13.5304C13.2368 13.8232 12.7619 13.8232 12.469 13.5303L10 11.061L7.531 13.5303C7.23812 13.8232 6.76325 13.8232 6.47034 13.5304C6.17743 13.2375 6.1774 12.7626 6.47028 12.4697L8.9394 10.0003L6.46964 7.5303C6.17676 7.23739 6.17679 6.76252 6.4697 6.46964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotify);
export default __webpack_public_path__ + "static/media/error-notify.09e748e91841f2f4b64034664daacc64.svg";
export { ForwardRef as ReactComponent };